/* eslint-disable newline-per-chained-call */

/** Transform to sha256 the input string */
export async function sha256(input: string) {
  const textAsBuffer = new TextEncoder().encode(input)
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hash = hashArray
    .map(item => item.toString(16).padStart(2, '0'))
    .join('')
  return hash
}
